import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '@views/home/home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@views/_landings/portfolio/portfolio.vue'),
    },
    // {
    //     path: '/landings/mobile-app',
    //     name: 'Mobile App',
    //     component: () => import('@views/_landings/mobile-app/mobile-app.vue'),
    // },
    // {
    //     path: '/landings/desktop-app',
    //     name: 'Desktop App',
    //     component: () => import('@views/_landings/desktop-app/desktop-app.vue'),
    // },
    // {
    //     path: '/landings/multipurpose',
    //     name: 'Multipurpose',
    //     component: () =>
    //         import('@views/_landings/multipurpose/multipurpose.vue'),
    // },
    // {
    //     path: '/landings/agency',
    //     name: 'Agency',
    //     component: () => import('@views/_landings/agency/agency.vue'),
    // },
    // {
    //     path: '/landings/press',
    //     name: 'Press',
    //     component: () => import('@views/_landings/press/press.vue'),
    // },
    // {
    //     path: '/landings/directory',
    //     name: 'Directory',
    //     component: () => import('@views/_landings/directory/directory.vue'),
    // },
    // {
    //     path: '/landings/rental',
    //     name: 'Rental',
    //     component: () => import('@views/_landings/rental/rental.vue'),
    // },
    // {
    //     path: '/landings/real-estate',
    //     name: 'Real Estate',
    //     component: () => import('@views/_landings/real-estate/real-estate.vue'),
    // },
    // {
    //     path: '/landings/classifieds',
    //     name: 'Classifieds',
    //     component: () => import('@views/_landings/classifieds/classifieds.vue'),
    // },
    // {
    //     path: '/landings/lead-capture',
    //     name: 'Lead Capture',
    //     component: () =>
    //         import('@views/_landings/lead-capture/lead-capture.vue'),
    // },
    {
        path: '/resume',
        name: 'Resume',
        component: () => import('@views/_landings/resume/resume.vue'),
    },
    // {
    //     path: '/landings/portfolio',
    //     name: 'Portfolio',
    //     component: () => import('@views/_landings/portfolio/portfolio.vue'),
    // },
    // {
    //     path: '/headers/basic',
    //     name: 'Basic Header',
    //     component: () => import('@views/_headers/basic/basic.vue'),
    // },
    // {
    //     path: '/headers/basic-signup',
    //     name: 'Basic Signup',
    //     component: () =>
    //         import('@views/_headers/basic-signup/basic-signup.vue'),
    // },
    // {
    //     path: '/headers/graphic',
    //     name: 'Graphic',
    //     component: () => import('@views/_headers/graphic/graphic.vue'),
    // },
    // {
    //     path: '/headers/graphic-signup',
    //     name: 'Graphic Signup',
    //     component: () =>
    //         import('@views/_headers/graphic-signup/graphic-signup.vue'),
    // },
    // {
    //     path: '/headers/inner-page',
    //     name: 'Inner Page',
    //     component: () => import('@views/_headers/inner-page/inner-page.vue'),
    // },
    // {
    //     path: '/headers/nav-only',
    //     name: 'Nav Only',
    //     component: () => import('@views/_headers/nav-only/nav-only.vue'),
    // },
    // {
    //     path: '/pages/basic',
    //     name: 'Basic Page',
    //     component: () => import('@views/_pages/basic/basic.vue'),
    // },
    // {
    //     path: '/about',
    //     name: 'About Me',
    //     component: () =>
    //         import('@views/_pages/company-about/company-about.vue'),
    // },
    // {
    //     path: '/pages/company-pricing',
    //     name: 'Company Pricing',
    //     component: () =>
    //         import('@views/_pages/company-pricing/company-pricing.vue'),
    // },
    {
        path: '/contact',
        name: 'Contact Me',
        component: () =>
            import('@views/_pages/company-contact/company-contact.vue'),
    },
    // {
    //     path: '/pages/company-terms',
    //     name: 'Company Terms',
    //     component: () =>
    //         import('@views/_pages/company-terms/company-terms.vue'),
    // },
    // {
    //     path: '/pages/help-center',
    //     name: 'Help Center',
    //     component: () => import('@views/_pages/help-center/help-center.vue'),
    // },
    // {
    //     path: '/pages/help-knowledgebase',
    //     name: 'Help Knowledgebase',
    //     component: () =>
    //         import('@views/_pages/help-knowledgebase/help-knowledgebase.vue'),
    // },
    // {
    //     path: '/pages/help-message-center',
    //     name: 'Help Message Center',
    //     component: () =>
    //         import('@views/_pages/help-message-center/help-message-center.vue'),
    // },
    // {
    //     path: '/pages/help-support-ticket',
    //     name: 'Help Support Ticket',
    //     component: () =>
    //         import('@views/_pages/help-support-ticket/help-support-ticket.vue'),
    // },
    // {
    //     path: '/pages/careers-overview',
    //     name: 'Careers Overview',
    //     component: () =>
    //         import('@views/_pages/careers-overview/careers-overview.vue'),
    // },
    // {
    //     path: '/pages/careers-listing',
    //     name: 'Careers Listing',
    //     component: () =>
    //         import('@views/_pages/careers-listing/careers-listing.vue'),
    // },
    // {
    //     path: '/pages/blog-overview',
    //     name: 'Blog Overview',
    //     component: () =>
    //         import('@views/_pages/blog-overview/blog-overview.vue'),
    // },
    // {
    //     path: '/pages/blog-post',
    //     name: 'Blog Post',
    //     component: () => import('@views/_pages/blog-post/blog-post.vue'),
    // },
    // {
    //     path: '/pages/blog-archive',
    //     name: 'Blog Archive',
    //     component: () => import('@views/_pages/blog-archive/blog-archive.vue'),
    // },
    // {
    //     path: '/pages/portfolio-grid',
    //     name: 'Portfolio Grid',
    //     component: () =>
    //         import('@views/_pages/portfolio-grid/portfolio-grid.vue'),
    // },
    // {
    //     path: '/portfolio',
    //     name: 'Portfolio Large Grid',
    //     component: () =>
    //         import(
    //             '@views/_pages/portfolio-large-grid/portfolio-large-grid.vue'
    //         ),
    // },
    // {
    //     path: '/pages/portfolio-masonry',
    //     name: 'Portfolio Masonry',
    //     component: () =>
    //         import('@views/_pages/portfolio-masonry/portfolio-masonry.vue'),
    // },
    // {
    //     path: '/pages/portfolio-case-study',
    //     name: 'Portfolio Case Study',
    //     component: () =>
    //         import(
    //             '@views/_pages/portfolio-case-study/portfolio-case-study.vue'
    //         ),
    // },
    // {
    //     path: '/project',
    //     name: 'Portfolio Project',
    //     component: () =>
    //         import('@views/_pages/portfolio-project/portfolio-project.vue'),
    // },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;

// router-link.d-block.rounded-lg.lift.lift-lg(to='/landings/basic')
